
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';

  export default defineComponent({
    name: 'vehicles-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      const searchItems = async (input) => {
        await store.dispatch(Actions.UPDATE_VEHICLES_FILTER, {
          vehicleName: input,
        });
        await store.dispatch(Actions.GET_VEHICLES);
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('vehiclesListing'), [
          translate('assets'),
        ]);
        loading.value = true;
        await store.dispatch(Actions.GET_VEHICLES);
        loading.value = false;
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_VEHICLES_STORE);
      });

      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('nameAr'),
          key: 'nameAr',
          sortable: true,
        },
        {
          name: translate('nameEn'),
          key: 'nameEn',
          sortable: true,
        },
        {
          name: translate('nameKu'),
          key: 'nameKu',
          sortable: true,
        },
        {
          name: translate('status'),
          key: 'isActive',
          sortable: true,
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);
      const toggleStatusVehicle = async (vehicle) => {
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(Actions.DELETE_VEHICLE, vehicle.id);
          await store.dispatch(Actions.GET_VEHICLES);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          }
        }
      };

      const editVehicle = (id) => {
        router.push({ name: 'vehicle-editing', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val, fromSearch) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_VEHICLE_CURRENT_PAGE, val);
        await store.dispatch(
          Actions.GET_VEHICLES,
          fromSearch ? val : undefined
        );

        loading.value = false;
      };

      return {
        tableData: computed(() => store.getters.vehiclesList),
        tableHeader,
        searchItems,
        input: '',
        toggleStatusVehicle,
        translate,
        totalItems: computed(() => store.getters.vehiclesListCount),
        pageChanged,
        goTo,
        editVehicle,
        loading,
        can,
      };
    },
  });
